import { useState } from "preact/hooks";
import PropTypes from "prop-types";
import SearchBar from "@/components/input/search-bar.input.jsx";

CommandTable.propTypes = {
  commands: PropTypes.array,
};

export default function CommandTable({ commands }) {
  const [searchValue, setSearchValue] = useState("");
  const filteredCommands = commands.filter((command) => {
    if (searchValue.length > 0) {
      if (Array.isArray(command.command)) {
        return command.command.join(",").toLowerCase().includes(searchValue);
      }
      return command.command.toLowerCase().includes(searchValue);
    }
    return true;
  });

  return (
    <div className="card bg-base-300 h-96 overflow-hidden">
      <div className="card-body gap-0 flex flex-col p-0 overflow-hidden">
        <div className="p-4">
          <SearchBar onSearch={setSearchValue} />
        </div>
        <div className="flex-grow overflow-y-scroll">
          <table className="table table-zebra table-pin-rows">
            <thead>
              <tr className="bg-base-200">
                <th className="min-w-48">Command</th>
                <th className="w-full">Description</th>
              </tr>
            </thead>
            <tbody>
              {filteredCommands.map((command) => (
                <tr key={command.command}>
                  <td className="w-32">
                    {Array.isArray(command.command) ? (
                      command.command.map((cmd, i) => (
                        <div key={cmd}>
                          <pre>
                            {cmd}
                            {i < command.command.length - 1 && ", "}
                          </pre>
                        </div>
                      ))
                    ) : (
                      <pre>{command.command}</pre>
                    )}
                  </td>
                  <td>{command.description}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
